import React from "react"

import { useEvent } from "shared/lib/useEvent"
import { Toggle } from "shared/ui/input/boolean/toggle/Toggle"

export interface AddonAccordionToggleProps {
  addonKey: string
  title?: string
  isSelected?: boolean
  isDisabled?: boolean
  onToggle?: (key: string) => void
}

export const AddonAccordionToggle = React.memo(
  ({
    addonKey,
    title,
    isSelected,
    isDisabled,
    onToggle
  }: AddonAccordionToggleProps) => {
    const handleChange = useEvent(() => {
      onToggle?.(addonKey)
    })

    // Prevents the click from bubbling to the accordion header, which would
    // otherwise also toggle the card's expanded state.
    const handleClick = useEvent((event: React.MouseEvent) => {
      event.stopPropagation()
    })

    // No `name`: the accordion is not inside a FormProvider, so the toggle has
    // to stay controlled by the addon selection state.
    return (
      <Toggle.Root
        inputID={`${addonKey}__toggle`}
        label={title}
        disabled={isDisabled}
        className="addon-accordion__toggle"
      >
        <Toggle.Input
          checked={!!isSelected}
          onChange={handleChange}
          onClick={handleClick}
        />
      </Toggle.Root>
    )
  }
)
